import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/login/Login.vue'
import Index from '@/components/index/Index.vue'
import homeRoute from '@/components/homeRoute/index.vue'
import forgetPwd from '@/components/login/forgetPwd.vue'
import ScreenDetect from '@/components/vision/ScreenDetect.vue'
import strabismus_blance from '@/components/vision/strabismus_blance.vue'
import amblyopia_blance from '@/components/vision/amblyopia_blance.vue'
import worthFour from '@/components/vision/worthFour.vue'
import eyePosition from '@/components/vision/eyePosition.vue'
import TrainIframe from '@/components/vision/TrainIframe.vue'
import visionHistory from '@/components/vision/visionHistory.vue'
import dafanweilitishi from '@/components/vision/dafanweilitishi.vue'
import xiantiaoronghe from '@/components/vision/xiantiaoronghe.vue'
import xiantiaolitishi from '@/components/vision/xiantiaolitishi.vue'
import batchCheck from '@/components/vision/batchCheck.vue'
import basicIFrameView from '@/components/vision/basicIFrameView.vue'
import BrowserTip from '@/components/browserTip/BrowserTip.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/forgetPwd',
      component: forgetPwd
    },
    {
      path: '/browsertip',
      component: BrowserTip,
      props: true
    },
    {
      path: '/index',
      component: Index,
      children: [{
          path: 'homeRoute',
          component: homeRoute,
          props: true
        },
        {
          path: 'resolution',
          component: ScreenDetect,
          props: true
        },
        {
          path: 'basicIFrameView/:key/:gamePath',
          component: basicIFrameView,
          props: true
        },
        {
          path: 'strabismus_blance',
          component: strabismus_blance,
          props: true
        },
        {
          path: 'amblyopia_blance',
          component: amblyopia_blance,
          props: true
        },
        {
          path: 'vision',
          component: TrainIframe,
          props: true
        },
        {
          path: 'visionHistory',
          component: visionHistory,
          props: true
        },
        {
          path: 'worthFour',
          component: worthFour,
          props: true
        },
        {
          path: 'eyePosition',
          component: eyePosition,
          props: true
        },
        {
          path: 'xiantiaoronghe',
          component: xiantiaoronghe,
          props: true

        },
        {
          path: 'dafanweilitishi',
          component: dafanweilitishi,
          props: true

        },
        {
          path: 'xiantiaolitishi',
          component: xiantiaolitishi,
          props: true

        },
        {
          path: 'batchCheck',
          component: batchCheck,
          props: true
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js